<!-- Posting entity tab -->
@if (ctx.loadingEntityPostingData) {
<div class="formLoader text-center">
  <i class="fa fa-spinner fa-spin gt-refresh"></i>
</div>
}
@if (!ctx.loadingEntityPostingData) {
<div class="form-horizontal tax-attrib-entity-posting-block">
  <div class="row" style="margin-bottom: 12px;">
    <div class="col-md-6">
      <div class="col-md-4 noWrap"><label>Entity :</label></div>
      <div class="col-md-6">
        @if (ctx.gridRowData) {
<input type="text" class="form-control" name="entityName" [(ngModel)]="ctx.selectedEntity" readonly>
}
      </div>
    </div>
    <div class="col-md-6">
      <div class="col-md-4 noWrap"><label>LEID:</label></div>
      <div class="col-md-6">
        @if (ctx.activateEntityDropdown) {
<input type="text" class="form-control" name="leid2" [(ngModel)]="ctx.leid2" readonly>
}
        @if (!ctx.activateEntityDropdown) {
<input type="text" class="form-control" name="leid" [(ngModel)]="ctx.leid" readonly>
}
      </div>
    </div>
  </div>
  <div class="row" style="margin-bottom: 12px;">
    <div class="col-md-6">
      <div class="col-md-4 noWrap"><label>Select Posting Entity :</label></div>
      <div class="col-md-6">
        <select gtwSearchableSelect searchPlaceholder="Search entity..."
                class="form-control" name="postingEntitySelect"
                [(ngModel)]="ctx.selectedEntity2" (ngModelChange)="ctx.setNewEntityDtls($event)">
          <option value="">-- Select --</option>
          @for (s of ctx.taxAttribEntityData; track $index) {
<option [value]="s.LEID_DTS">{{ s.LEID_DTS }}</option>
}
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div class="col-md-4 noWrap"><label>TAX CODE:</label></div>
      <div class="col-md-6">
        @if (ctx.activateEntityDropdown) {
<input type="text" class="form-control" name="cdrNo2" [(ngModel)]="ctx.cdrNo2" readonly>
}
        @if (!ctx.activateEntityDropdown) {
<input type="text" class="form-control" name="cdrNo" [(ngModel)]="ctx.cdrNo" readonly>
}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6"></div>
    <div class="col-md-6">
      <div class="col-md-4 noWrap"><label>REPORTING PERIOD:</label></div>
      <div class="col-md-6">
        @if (ctx.activateEntityDropdown) {
<input type="text" class="form-control" name="rp2" [(ngModel)]="ctx.rp2" readonly>
}
        @if (!ctx.activateEntityDropdown) {
<input type="text" class="form-control" name="rp" [(ngModel)]="ctx.rp" readonly>
}
      </div>
    </div>
  </div>
</div>
}
